import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-box3-werkelijkRendement',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-box3-werkelijkRendement.component.html',
  styleUrl: './tekst-box3-werkelijkRendement.component.scss',
})
export class TekstBox3WerkelijkRendementComponent implements OnInit {

  @Input() public id!: string;
  public ibAangifte = {} as Aangifte;
  public focusedElementId: string | null = null;
  public year = 2024;
  public actualYear: number = new Date().getFullYear();


  constructor(
      public dataService: BokkzIbDataService) {
  }

  ngOnInit(): void {
    this.dataService.incomeTaxEntity.subscribe((value) => {
      if (value.year !== undefined) {
        this.year = value.year;
      }
    })
  }

}

